import AutoGeneratedEnumSelect from './AutoGeneratedEnumSelect';

import {
  AuthorizeTypeSelect,
  BudgetLineItemBudgetTypeSelect,
  BudgetSummaryStatusSelect,
  BusinessDayTypeSelect,
  CertificationAreaSelect,
  ChassisConfigurationSelect,
  CognosLogStatusSelect,
  ContractDocumentSelect,
  ContractVehicleTypeSelect,
  DriverBriefingViewSelect,
  DriverStatusSelect,
  EmployeeBriefingViewSelect,
  EmployeeCertificationViewSelect,
  EngineTypeSelect,
  EntityTypeSelect,
  ExpenseDirectionCognosStatusSelect,
  ExpenseDirectionDisplayRuleTypeSelect,
  ExpenseDirectionTypeSelect,
  FuelAndOilViewSelect,
  FuelGroupSelect,
  FuelTypeCalculationSelect,
  FuelTypeSelect,
  InsuranceClassSelect,
  LeasersSelect,
  MaintenanceOilsSelect,
  MaintenanceOperationStatusSelect,
  MaintenanceStatusesTypeSelect,
  MaintenanceTypeOfWorkSelect,
  MaintenanceTypeSelect,
  MeasureTypeFuelPriceSelect,
  MedicOwnerTypeSelect,
  MonthSelect,
  MonthlyWashingPlanStatusSelect,
  MonthsSelect,
  OperatingModeSelect,
  OperationTypeSelect,
  OrderContractorTypeSelect,
  OrderObjectiveSelect,
  OrderTypeDispatcherSelect,
  OrderTypeSelect,
  OsagoCalculationStatusSelect,
  OsagoTransportTypeSelect,
  PositionSelect,
  PseudoNameSelect,
  RateTypeSelect,
  RepairePlanSelect,
  STSTypeSelect,
  ServiceOrderTypeSelect,
  TariffTypeSelect,
  ThirdPartyPositionSelect,
  TrainingViewSelect,
  VehicleIssueTypeSelect,
  VehicleOvbTypeSelect,
  WashingStatusSelect,
  WashingTypeSelect,
  WorkHourPriceSelect,
  TripsTypeDispatcherSelect
} from './AutoGeneratedEnumSelects';
import BatterySelect from './BatterySelect';
import BranchBudgetSummaryExpenseDirectionSelect from './BranchBudgetSummaryExpenseDirectionSelect';
import BranchBudgetSummaryLineItemSelect from './BranchBudgetSummaryLineItemSelect';
import BranchBudgetSummaryMonthSelect from './BranchBudgetSummaryMonthSelect';
import BranchBudgetSummarySelect from './BranchBudgetSummarySelect';
import BranchSmiaSelect from './BranchSmiaSelect';
import BrandsSelect from './BrandsSelect';
import BudgetLineItemSelect from './BudgetLineItemSelect';
import BudgetVersionSelect from './BudgetVersionSelect';
import CognosContractsSelect from './CognosContractsSelect';
import CompanyNameSelect from './CompanyNameSelect';
import CompanySelect from './CompanySelect';
import ContractSelect from './ContractSelect';
import ContractServiceSelect from './ContractServiceSelect';
import ContractVehicleSelect from './ContractVehicleSelect';
import ContractorSelect from './ContractorSelect';
import DriverLicenseCategorySelect from './DriverLicenseCategorySelect';
import DriverQualificationSelect from './DriverQualificationSelect';
import DriverSelect from './DriverSelect';
import EmployeePositionSelect from './EmployeePositionSelect';
import EmployeePositionSimpleSelect from './EmployeePositionSimpleSelect';
import EmployeeSelect from './EmployeeSelect';
import EmployeeSelectAll from './EmployeeSelectAll';
import EntityStatusSelect from './EntityStatusSelect';
import ExpenseDirectionSelect from './ExpenseDirectionSelect';
import ExpenseDirectionTreeSelect from './ExpenseDirectionTreeSelect';
import FuelAndOilSelect from './FuelAndOilSelect';
import FuelMultipliersSelect from './FuelMultipliersSelect';
import HourSelect from './HourSelect';
import ISUBudgetingSelect from './ISUBudgetingSelect';
import IncomeScheduleSelect from './IncomeScheduleSelect';
import JobTitleSelect from './JobTitleSelect';
import JournalTypeSelect from './JournalTypeSelect';
import LocationSelect from './LocationSelect';
import MaintenanceMatrixValidActionSelect from './MaintenanceMatrixValidActionSelect';
import MaintenanceOperationGroupSelect from './MaintenanceOperationGroupSelect';
import MaintenanceOperationSelect from './MaintenanceOperationSelect';
import MaintenanceWorkTypeSelect from './MaintenanceWorkTypeSelect';
import MdmSelect from './MdmSelect';
import OverhaulTypeSelect from './OverhaulTypeSelect';
import PlaceSelect from './PlaceSelect';
import RateTaxesSelect from './RateTaxesSelect';
import RegistrationPlaceSelect from './RegistrationPlaceSelect';
import RegulationSelect from './RegulationSelect';
import SecuringContractorSelect from './SecuringContractorSelect';
import StageSelect from './StageSelect';
import StockPartSelect from './StockPartSelect';
import StockSelect from './StockSelect';
import StouSelect from './StouSelect';
import ThirdPartyCompanySelect from './ThirdPartyCompanySelect';
import ThirdPartyEmployeeSelect from './ThirdPartyEmployeeSelect';
import TireSelect from './TiresSelect';
import TripSelect from './TripSelect';
import UserAccessTypesSelect from './UserAccessTypesSelect';
import UserRoleSelect from './UserRoleSelect';
import UserSelect from './UserSelect';
import VehicleCategorySelect from './VehicleCategorySelect';
import VehicleContractPlanSelect from './VehicleContractPlanSelect';
import VehicleIssueGroupSelect from './VehicleIssueGroupSelect';
import VehicleModelSelect from './VehicleModelSelect';
import VehicleOwnerTypeSelect from './VehicleOwnerTypeSelect';
import VehiclePlanSelect from './VehiclePlanSelect';
import VehiclePlanStatusSelect from './VehiclePlanStatusSelect';
import VehicleSelect from './VehicleSelect';
import VehicleStatusSelect from './VehicleStatusSelect';
import VehicleSubCategorySelect from './VehicleSubCategorySelect';
import VehicleTariffByTypeSelect from './VehicleTariffByTypeSelect';
import VehicleTaxRateSelect from './VehicleTaxRateSelect';
import VehicleTypeSelect from './VehicleTypeSelect';
import YearIssueSelect from './YearIssueSelect';
import YearSelect from './YearSelect';
import YearVehicleSelect from './YearVehicleSelect';
import YesNoSelect from './YesNoSelect';
import AttachmentsSelect from './equipment/AttachmentsSelect';
import OptionalsTypeSelect from './equipment/OptionalsTypeSelect';

export default {
  BranchBudgetSummaryLineItemSelect,
  BranchBudgetSummaryExpenseDirectionSelect,
  PlaceSelect,
  BranchSmiaSelect,
  VehiclePlanStatusSelect,
  RegulationSelect,
  BudgetVersionSelect,
  ContractVehicleTypeSelect,
  RateTypeSelect,
  MeasureTypeFuelPriceSelect,
  OsagoCalculationStatusSelect,
  TripSelect,
  IncomeScheduleSelect,
  YearSelect,
  RateTaxesSelect,
  StageSelect,
  EntityStatusSelect,
  MaintenanceMatrixValidActionSelect,
  MaintenanceStatusesTypeSelect,
  MaintenanceWorkTypeSelect,
  MaintenanceTypeOfWorkSelect,
  EntityTypeSelect,
  OrderTypeDispatcherSelect,
  StockPartSelect,
  MdmSelect,
  VehicleIssueGroupSelect,
  BatterySelect,
  TireSelect,
  OrderContractorTypeSelect,
  MedicOwnerTypeSelect,
  DriverSelect,
  VehicleSelect,
  AttachmentsSelect,
  BrandsSelect,
  OptionalsTypeSelect,
  FuelTypeSelect,
  FuelGroupSelect,
  VehicleTypeSelect,
  VehicleModelSelect,
  LocationSelect,
  EmployeeSelect,
  ThirdPartyEmployeeSelect,
  EmployeeSelectAll,
  FuelAndOilSelect,
  VehicleStatusSelect,
  OrderObjectiveSelect,
  UserAccessTypesSelect,
  PositionSelect,
  ThirdPartyPositionSelect,
  DriverStatusSelect,
  InsuranceClassSelect,
  CompanySelect,
  ThirdPartyCompanySelect,
  CompanyNameSelect,
  ContractorSelect,
  ContractServiceSelect,
  MaintenanceTypeSelect,
  MaintenanceOperationSelect,
  OperatingModeSelect,
  TariffTypeSelect,
  ServiceOrderTypeSelect,
  WashingTypeSelect,
  WashingStatusSelect,
  VehicleIssueTypeSelect,
  UserRoleSelect,
  FuelMultipliersSelect,
  MaintenanceOperationStatusSelect,
  MaintenanceOperationGroupSelect,
  DriverBriefingViewSelect,
  TrainingViewSelect,
  EmployeeCertificationViewSelect,
  EmployeeBriefingViewSelect,
  ContractVehicleSelect,
  DriverLicenseCategorySelect,
  OrderTypeSelect,
  AuthorizeTypeSelect,
  JournalTypeSelect,
  YearIssueSelect,
  YearVehicleSelect,
  VehicleOvbTypeSelect,
  JobTitleSelect,
  UserSelect,
  BusinessDayTypeSelect,
  YesNoSelect,
  ChassisConfigurationSelect,
  HourSelect,
  DriverQualificationSelect,
  EngineTypeSelect,
  VehicleCategorySelect,
  VehicleSubCategorySelect,
  StouSelect,
  MonthlyWashingPlanStatusSelect,
  CertificationAreaSelect,
  RepairePlanSelect,
  VehicleOwnerTypeSelect,
  ExpenseDirectionSelect,
  ExpenseDirectionTreeSelect,
  ContractSelect,
  OsagoTransportTypeSelect,
  ExpenseDirectionTypeSelect,
  WorkHourPriceSelect,
  AutoGeneratedEnumSelect,
  STSTypeSelect,
  EmployeePositionSelect,
  VehicleTaxRateSelect,
  PseudoNameSelect,
  MonthsSelect,
  FuelTypeCalculationSelect,
  OperationTypeSelect,
  OverhaulTypeSelect,
  BudgetLineItemSelect,
  StockSelect,
  VehiclePlanSelect,
  VehicleContractPlanSelect,
  BudgetSummaryStatusSelect,
  MaintenanceOilsSelect,
  BranchBudgetSummarySelect,
  RegistrationPlaceSelect,
  ContractDocumentSelect,
  ExpenseDirectionDisplayRuleTypeSelect,
  BranchBudgetSummaryMonthSelect,
  BudgetLineItemBudgetTypeSelect,
  MonthSelect,
  VehicleTariffByTypeSelect,
  FuelAndOilViewSelect,
  ISUBudgetingSelect,
  CognosLogStatusSelect,
  ExpenseDirectionCognosStatusSelect,
  CognosContractsSelect,
  SecuringContractorSelect,
  EmployeePositionSimpleSelect,
  LeasersSelect,
  TripsTypeDispatcherSelect
};
